import React from "react";
import "./draw-game.css";

export default function DrawGame({
  background,
  button,
  logo,
}: {
  logo?: string;
  button?: string;
  background?: string;
  isMobile: boolean;
}) {
  // const [isAnimating, setIsAnimating] = useState(false);

  // const handleAnimationEnd = () => {
  //   afterAnimation();
  //   setIsAnimating(false);
  // };

  // const startAnimation = () => {
  //   setIsAnimating(true);
  // };

  const afterAnimation = () => {
    const url = [
      "https://h4winaus.com/RF266121065",
      "https://rr4winaus.com/RF266121821",
      "https://pg9aus.com/RF9960A59",
      "https://rr4winaus.com/RF266121821",
      "https://h4winaus.com/RF266121065",
      "https://pg9aus.com/RF9960A59",
      "https://boomerangaus.com/RF36A7259A6"
    ];
    const randomItem = url[Math.floor(Math.random() * url.length)];
    const newWindow = window.open(randomItem, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.focus();
  };

  return (
    <button
      style={{
        padding: "0px",
        margin: "0px",
        backgroundColor: "transparent",
        border: "none",
      }}
      onClick={afterAnimation}
    >
      <div
        className={`draw-item`}
        style={{
          display: "flex",
          alignItems: "flex-end",
          height: "98.5%",
          marginBottom: "3px",
        }}
      >
        <img
          // onAnimationEnd={handleAnimationEnd}
          // className={`${isAnimating ? "spin-3x" : ""}`}
          src={logo}
          width={"62%"}
          alt="Draw now"
          style={{
            objectFit: "contain",
            position: "absolute",
            top: 0,
            left: "19%",
            right: "19%",
            zIndex: 999,
          }}
        />
        <img
          className="draw-item-bg"
          src={background}
          width={"100%"}
          alt="Draw now"
          style={{ objectFit: "contain" }}
        />
        <div
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px",
            position: "absolute",
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
          }}
        >
          <img src={button} alt="ButtonBg" className={`draw-animation`} />
        </div>
      </div>
    </button>
  );
}
